import React from 'react';
import { DialogTitle, DialogDescription } from '@/components/ui/dialog';

/**
 * Glass-band header for action modals — matches Payment Schedule overlays.
 * Use variant="dialog" inside Radix Dialog; variant="plain" for framer shells.
 */
export default function ActionModalHeader({
  icon: Icon,
  title,
  description,
  variant = 'plain',
}) {
  const TitleTag = variant === 'dialog' ? DialogTitle : 'h2';
  const DescTag = variant === 'dialog' ? DialogDescription : 'p';

  return (
    <div className="relative flex-shrink-0 overflow-hidden border-b border-white/[0.06]">
      <div className="absolute inset-0 bg-gradient-to-b from-white/[0.07] via-white/[0.025] to-transparent pointer-events-none" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 70% 140% at 8% 0%, rgba(10, 18, 51, 0.18), transparent 65%)' }}
      />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/[0.18] to-transparent pointer-events-none" />
      <div className="relative flex items-start gap-3 px-4 py-4 sm:px-6 sm:py-5 pr-12 sm:pr-12 text-left">
        {Icon && (
          <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-brand-800 border border-brand-700/40 shadow-[0_0_16px_-4px_rgba(10,18,51,0.55)] flex items-center justify-center">
            <Icon className="w-4 h-4 text-white" />
          </div>
        )}
        <div className="min-w-0 pt-0.5">
          <TitleTag className="text-white/95 font-medium text-xs uppercase tracking-widest leading-tight">
            {title}
          </TitleTag>
          {description && (
            <DescTag className="text-white/55 text-xs font-normal leading-snug mt-1.5">
              {description}
            </DescTag>
          )}
        </div>
      </div>
    </div>
  );
}
